import { development } from "../../../abraj-shared/src/public-api";

export const environment = {
    production: false,
    config:development
}
